import { Predicate } from "@siteimprove/alfa-predicate";
const { equals } = Predicate;
export function hasNamespace(namespaceOrPredicate, ...namespaces) {
    let predicate;
    if (typeof namespaceOrPredicate === "function") {
        predicate = namespaceOrPredicate;
    }
    else {
        predicate = equals(namespaceOrPredicate, ...namespaces);
    }
    return (element) => element.namespace.some(predicate);
}
//# sourceMappingURL=has-namespace.js.map